import { RootState } from "..";

// Selectors
export const selectProvider = (state: RootState) => state.provider;
export const selectIsProviderLoggedIn = (state: RootState) => state.provider.isLoggedIn;
export const selectIsConfirmEmail = (state: RootState) => state.provider.isConfirmEmail;
export const selectIsProviderLoading = (state: RootState) => state.provider.loading;
export const selectIsResetPassLoading = (state: RootState) => state.provider.resetPassLoading;
export const selectIsVerified = (state: RootState) => state.provider.isVerified;
export const selectUser = (state: RootState) => state.provider.user;
export const selectDashboard = (state: RootState) => state.provider.user.dashboard;